module.exports = __webpack_public_path__ + "static/media/6-1.15324ac6.mp3";